import sicceLangs from "./Traduzioni/Sicce/Languages";
import fogLangs from "./Traduzioni/FogSolution/Languages";

const URLs = {
  sicce: {
    baseUrl: "/Sicce-ContrAll",
    langs: sicceLangs,
  },
  fogsolution: {
    baseUrl: "/FogSolution",
    langs: fogLangs,
  },
};

const routes = {
  fogsolutionPrivacyPolicy: "/FogSolution/PrivacyPolicy",
  404: "/404",
};

for (const [url, { baseUrl, langs }] of Object.entries(URLs)) {
  routes[url] = {
    home: baseUrl,
    langs: Object.fromEntries(
      Object.keys(langs).map((lang) => [lang, `${baseUrl}/${lang}`]),
    ),
  };
}

export { URLs };
export default routes;
